import { useEffect } from 'react';
import { Card, CardContent, CardHeader, IconButton } from '@mui/material';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import { CrossIcon } from 'assets';
import { MessagesList, ChatInput } from 'components';
import { useChat, useIsGuestCall, useRoomRightSidebar } from 'hooks';

import styles from './GroupChat.module.scss';

type GroupChatProps = {
  className?: string;
};

export function GroupChat({ className }: GroupChatProps): JSX.Element {
  const { t } = useTranslation('providerRoom');
  const isGuestCall = useIsGuestCall();
  const forceLightThemeForGuest = isGuestCall && localStorage.getItem('app-theme') === null;
  const { roomConversation, closeRoomChat, sendMessageToRoomChat } = useChat();
  const { hideSidebar } = useRoomRightSidebar();

  const preferredChatName = t('groupChatTitle');

  // **replaced logic to always show GROUP CHAT as card title
  // const { preferedDisplayName } = waitingRoomProfile || {};

  // const preferredChatName = useMemo(() => {
  //   const resolvedDisplayName = typeof preferedDisplayName === 'string' ? preferedDisplayName : '';
  //   const resolvedChatName = typeof chatName === 'string' ? chatName : '';

  //   return resolvedDisplayName || resolvedChatName || 'CHAT';
  // }, [chatName, preferedDisplayName]);

  useEffect(() => {
    return () => {
      closeRoomChat();
    };
  }, []);

  const handleTyping = (): void => {
    roomConversation?.typing();
  };

  const handleSendMessage = (message: string | FormData): Promise<number> => {
    return sendMessageToRoomChat(message);
  };

  const handleClose = (): void => {
    hideSidebar();
    closeRoomChat();
  };

  return (
    <Card className={classnames(styles.groupChat, className, { [styles.forceLight]: forceLightThemeForGuest })}>
      <CardHeader
        title={preferredChatName}
        action={
          <IconButton edge='end' aria-label={t('aria.close')} onClick={handleClose}>
            <CrossIcon className={styles.close} color='primary' />
          </IconButton>
        }
      />
      <CardContent>
        {roomConversation ? (
          <MessagesList className={styles.messagesList} isGroup={true} forceLightTheme={forceLightThemeForGuest} />
        ) : (
          <div className={styles.emptyState}>{t('groupChatEmptyState')}</div>
        )}
        <ChatInput isGroup={true} onTyping={handleTyping} sendMessage={handleSendMessage} />
      </CardContent>
    </Card>
  );
}
